import React from 'react';
import Allocations from '../Allocations';
import CustomTabs from '../common/CustomTabs';
import PageHeader from '../common/PageHeader';
import Assignments from '../Assignments';
import PropertyDetails from './PropertyDetails';
import { IsSectionVisible } from '../../utils/helper';
import { SECTIONS } from '../../constants/appConstants';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
class PropertyInfo extends React.PureComponent {
  constructor(props) {
    super(props);
    // console.log(props.propertyData)
    this.state = {
      MarketDetails: undefined,
      PropertyData: undefined,
      configuration: undefined
    };
  }

  componentDidMount() { }

  render() {
    const Tabs = [
      {
        name: this.props.Editable ? 'Property Details' : 'View Property',
        id: 1,
        childComponent: (
          <PropertyDetails
            selectedPropertyId={this.props.selectedPropertyId}
            onBackClick={this.props.onBackClick}
            Editable={this.props.Editable}
            isClientSourceAccounting = {this.props.propertyData.length > 0 ? this.props.propertyData[0].sourceAccountingSystemId?.toString() === '2' : false}
          />
        )
      }
    ];
    if (IsSectionVisible(SECTIONS.ASSIGNMENTS)) {
      Tabs.push(
        {
          name: 'Assignment Details',
          id: 3,
          childComponent: (
            <Assignments
              selectedPropertyId={this.props.selectedPropertyId}
              renderAsChild={true}
            ></Assignments>
          )
        });
    }
    if (IsSectionVisible(SECTIONS.ALLOCATIONS, SECTIONS.PROPERTY_ALLOCATION)) {
      Tabs.push(
        {
          name: 'Employee Allocations',
          id: 2,
          childComponent: (
            <Allocations
              marketId={this.props.propertyData.length > 0 ? this.props.propertyData[0].marketId : null}
              selectedPropertyId={this.props.selectedPropertyId}
              selectedLegalEntityId = {this.props.selectedLegalEntityId}
              allocationType={[{ allocationType: 'Property' }]}
              renderAsChild={true}
              propertyData={this.props.propertyData}
              selectedTab={'Property'}
              clientId={this.props.propertyData.length > 0 ? this.props.propertyData[0].clientId : null}
              propertyName={this.props.propertyData.length > 0 ? this.props.propertyData[0].propertyName : null}
            ></Allocations>
          )
        });
    }
    return (
      <>
        <div className="col-sm-12 col-lg-12">
          <PageHeader
            title="Property Details"
            actionsConfig={[
              {
                icon: <ArrowBackIcon size="small" className="back-button" />,
                onClick: this.props.onBackClick,
                title: 'Back to Property'
              }
            ]}
          ></PageHeader>
        </div>

        <div className="row Row_flex bottom-lg">
          <CustomTabs tabsList={Tabs} currentSelectedTab={1} />

          {/* <div className="col-sm-12 col-lg-1 bottom-lg">
            <Tooltip title="Back to Market">
              <ArrowBackIcon size="small" className="back-button" onClick={this.props.onBackClick} />
            </Tooltip>
          </div> */}
        </div>
      </>
    );
  }
}

export default PropertyInfo;
